var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "job-bot" },
    [
      _c("JonMessages", { attrs: { messages: _vm.messages } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "button-container" },
        [
          _c("Button", {
            style: { "animation-delay": _vm.messages.length + "s" },
            attrs: { text: "Los geht's", icon: "checkmark" },
            on: { click: _vm.start }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }